import { v4 as uuidv4 } from "uuid";

import {
  RecurringEventsType,
  RecurringRepeatOnDay,
  RecurringRepeatOnNumber,
  RecurringRepeatType,
} from '@/enums/RecurringEventsType';
import { Calendar } from "@/models/calendar/Calendar";

export class CreateEvent extends Calendar {
  startDate: string;
  duration: string;
  endDate: string;
  eventType: string;
  orgId: string;
  monthlyRepeatOn: { "position": RecurringRepeatOnNumber; "day": RecurringRepeatOnDay }[ ];

  constructor() {
    const date = new Date();
    super();
    this.parentEventId = uuidv4();
    this.duration = `${date.getHours()}:${date.getMinutes()}-${date.getHours() + 1}:${date.getMinutes()}`;
    this.isRecurring = false;
    this.recurringType = RecurringEventsType.Daily;
    this.recurringRepeatType = RecurringRepeatType.Day;
    this.recurringRepetitions = 1;
    this.recurringRepetitionsDays = [];
    this.monthlyRepeatOn = [
      { "position": RecurringRepeatOnNumber.First, "day": RecurringRepeatOnDay.Monday }
    ];
    this.noEndDate = false;
    this.endDate = "";
    this.conciergeRequestId = "";
    this.imageUrl = require("../../assets/no-image.jpg");
    this.thumbnailUrl = require("../../assets/no-image.jpg");
    this.residentCanSeeGuestList = false;
    this.isVirtualEvent = false;
    this.isWaitingList = false;
    this.allDay = false
  }
}
